export const FAQ = [
  {
    question: 'How to add an administrator',
    answer: `
      <p>1. Log into your Business Account on Quescreen using your email address.</p>
      <p>2. Go to "My business" via the left menu bar, click on Business Details</p>
      <p>3. Select Team on the left hand side of the screen, and then click on the orange button Add New</p>
      <p>4. Enter their details ie. Email, first name, last name</p>
      <p>5. Select a role for them Business administrator / Business staff based. Please read the permission each role includes. Generally, we recommend Business Administrator for full access.</p>  
      <p>6. Click Add at the bottom once you’ve double checked the details</p>
      <p>7. The staff will then receive a system email with instructions on how to set up their Admin account.</p>
    `,
  },
  {
    question: 'How to book a pre-employment screening on Quescreen',
    answer: `
      <p>1. Log into your Business Account on Quescreen using your email address.</p>
      <p>2. Once you on the Dashboard, click on &ldquo;Make a Booking&rdquo; in the orange box</p>
      <p>3. Select RECRUITMENT, and then click next</p>
      <p>4. Select a risk profile, and then click next</p>
      <p>5. Enter the candidate details (ie. Name and email address), and then click next</p>
      <p>6. Confirm all information and then click finalise</p>
      <p>7. Select a payment option and follow the steps on the screen. Candidates will receive their email to access Quescreen once the booking is paid.</p>
    `,
  },
  {
    question: 'How to delete, edit or duplicate an existing Risk Profile',
    answer: `
      <p>1. Log in to your business account</p>
      <p>2. Go to Risk Profile History through the left menu bar</p>
      <p>3. Click on the button with 3 dots on the right-hand side of an existing Risk Profile</p>
      <p>4. Choose "Duplicate" to make a copy, or choose "delete" to remove it permanently</p>
      <p>*Please note the "mark as draft option" is only available to Risk Profiles that have not been previously used to make any booking.</p>
    `,
  },
  {
    question: 'How to resend welcome email to candidate',
    answer: `
      <p>1. Login to your business dashboard.</p>
      <p>2. Go to Booking History via the left menu bar</p>
      <p>3. Look up the candidate name, and click on the booking</p>
      <p>4. Once you are in the booking information page, select "edit/send notification" button</p>
      <p>5. Tick "email" and/or "SMS", and then click "Update & Send notification"</p>
    `,
  },
  {
    question: 'How to check total completion number',
    answer: `
      <p>1. Log into your Business Account on Quescreen using your email address.</p>
      <p>2. Go to "Candidate Reports" via the left menu bar.</p>
      <p>3. Click "Show Filters", then filter "Status" to only show "Completed" individuals. Click "Submit" to confirm the filter setting.</p>
      <p>4. It should show you the number at the bottom of the page once the page finishes loading.</p>
    `,
  },
  {
    question: 'How to check credit balance',
    answer: `
      <p>1. Log in and go to <strong>Purchase</strong> through the left menu bar</p>
      <p>2. Click on <strong>"Purchase History"</strong></p>
      <p>3. You will see the credits remaining and their expiry date.</p>
    `,
  },
];
